import { getLink } from "../../../utils/utils";

const content = {
  esp: (
    `
    <div style="text-align: justify;">
        <p class="mb-3">
            Kiaj belaj estas miaj Esperantaj rememoroj! 
            Ili volviĝas kvazaŭ juvelŝtona kolierо, kaj ne eblas disigi ilin, apartigi unu de alia: ili faras mirindan ĉenon de impresoj, 
            de helaj makuloj sur verda fono, la fono de feliĉo. 
            Ĉiuj ili estas kunligitaj kun SEJT’oj – Sovetuniaj Esperantaj Junularaj Tendaroj, kiuj okazadis en nia lando de 1967 ĝis fino de 1990-j jaroj. 
            Tio estis unika evento en la monda E-movado: grandaj (de 200-300 personoj) renkontiĝoj de kreema junularo, 
            kiu proprainiciate kunvenis por krei dum 10 tagoj sian propran belan mondon, tute sendepende de politikaj kaj aliaj forpermesoj kaj baroj. 
            Mi havis feliĉon partopreni kelkajn SEJT’ojn.
        </p>
        
        <p class="mb-3">
            Al unua mia tendaro, en Litovio, mi veturis improvize, sen ajna kono pri ĝi. 
            Mi havis, certe, ian vortprovizon, ĉar multe legis, sed ne tro komprenis longajn parolojn. 
        </p>
        
        <p class="mb-3">
            Unua afero, kiu min trafis dum alveno, estis brakumoj kaj kisadoj de tiuj, kiuj renkontiĝis ĉi tie post antaŭjara tendaro. 
            Strange, tio ne kortuŝis min, sed iritis: jen fermita grupo, sed mi estas fremda kaj neniu atentas min. 
            Kaj unuaj tri tagoj pasis iom solece: kvankam ĉirkaŭe bolis la vivo, homoj venadis al iuj kunsidoj, seminarioj, prelegoj, 
            mi nur observis tiun vivon, kiu okazis sur fremda nordeca naturo, sub altaj pinoj (la unuaj tendaroj estis vere tendaj, sur freŝa aero). 
            La odoron de falinta pinglaro, varmigita de suno, mi memoras ĝis nun😀
        </p>
        
        <p class="mb-3">
            La tendaro estis organizita laŭ la principo de “lingva mergo”: la tuta vivo okazis nur en Esperanto, 
            kaj novulo, kiu ne alkutimiĝis al ĉiutaga parolado, sentis sin fremda kaj priridita, kio forpuŝis onin de l’ komunumo. 
            Mi jam revis foriri kaj neniam plu reveni al Eaj lokoj…
        </p>
        
        <p class="mb-3">
            Sed en la kvara tago okazis Miraklo.
        </p>
        
        <p class="mb-3">
            Min rimarkis unu malnova e-isto, kiu ofte venadis al Odessa kaj memoris min kiel “plej bonan lernantinon” de nia lerneja rondeto. 
            Tiam en nia urbo restis nur kelkaj maljunaj e-istoj, kaj apero de juna homo certe allogis atenton. 
            Kiel konate, Odeson oni nomas “la lulilo de Esperanto”, unua E-klubo estis fondita tie en 1894-96a jaroj; el Odessa devenis ekz., 
            V. A. Gernet, kiu en 1895-97 jj sponsoris kaj redaktis eldonatan en Svedio unuan E-revuon “La lingvo internacia”, N. Borovko, 
            al kiu L. Zamenhof adresis sian faman leteron pri deveno de Esperanto, poetoj A. Kofman, S.G. Rublov - unu el unuaj akademianoj… 
            Sed jen aperis tute nova, juna persono. 
            Ne mirinde, ke oni rimarkis min, prezentis al tiama prezidanto de SEJM Anatolo Gonĉarov, kiu ĝuste en Odessa eklernis esperanton… 
            kaj la kirlo entiris min!
        </p>
        
        <p class="mb-3">
            Ekde tiam ĉiuj miaj tagoj okazadis en kompanio de la plej interesaj homoj, mia pasiva vortprovizo transformiĝis en aktivan, mi multon eksciis kaj ekkomprenis. 
            Mi spertis tie la memstaran krean laboron de junularo. 
            Ni ĉion elpensis kaj plenumis mem; kaj tio estis oazo en medio de instrukcioj kaj ordonoj, estis libero de krea vivo, kiu donis al ni plenan radiantan feliĉon. 
            Tiel komenciĝis la plej belaj tagoj de mia vivo.
        </p>
        
        <p class="mb-3">
            Kiam venis tempo por mia dua tendaro, mi estis jam sufiĉe sperta e-istino, kaj informita, tuj ekflugis al Leningrado, 
            300 km de kiu, en arbaro apud urbeto Tihvin troviĝis la tendaro. 
             Ĉar mi venis sen tendo, oni lokigis min en grandan 10-lokan tendegon, kie loĝis fama e-isto (interalie, eks-odesano😀) kun sia 10-jara filo. 
            Ili okupis unu angulon de la tendo; mi ĵetis la dorsosakon en alian angulon kaj kuris ekkoni la kondiĉojn: programon, 
            lokon de lignofajro, kaj plej grave – renkontiĝi kun malnovaj amikoj kaj konatiĝi kun novaj. 

        </p>
        
        <p class="mb-3">
            Sed jen venis nokto…
        </p>
        
        <p class="mb-3">
            Ĉe ni en Odessa aŭgusto estas la plej varma monato de somero. 
            La maro, kiel rezervuaro, dum varmaj monatoj akumulas varmon, kaj poste fordonas ĝin, poiomete malvarmiĝante, kaj fariĝas rezervuaro de frido. 
            Tial ni havas friskan kaj pluvozan printempon, sed sekajn kaj varmajn aŭguston kaj septembron. 
            Do, kiel nesperta turisto, mi kunprenis en someran tendaron senmanikajn silkajn robojn kaj nur unu ventorezistan jaketon. 
            Kaj tute facilanime, anstataŭ rekomendita dormosako alportis tre maldikan kovrileton.
        </p>
        
        <p class="mb-3">
            Jen venis severa norda aŭgusta nokto… 
            En la tendoj forestis matracoj (ja dirite estis, ke oni prenu dormosakojn!), kaj mi provis ekdormi sur nuda tero, envolvita en mian mizeran tuketon. 
            En alia angulo patro kaj filo dormis sub aŭtentika ursa felo. 
            Kiel mi enviis ilin!
        </p>
        
        <p class="mb-3">
            Sed malvarmo penetris ĝisoste, kaj mi ne eltenis: elrampis el la tendo kaj ekiris serĉi saviĝon. 
            La savo troviĝis en formo de negranda lignofajro surborde de l’ rivero. 
            Tie varmiĝadis kelkaj povruloj, same kiel mi ne havantaj varmajn vestojn. 
            Komence ni estis nur kvarope: du junaj knaboj, mi kaj knabino, veninta por sia unua tendaro. 
             Ŝi gitarludis kaj kantis la tutan nokton, ni aŭskultis, kaj la nokto pasis nerimarkeble.
        </p>
        
        <p class="mb-3">
            Sed tage eblis satdormi en ajna fremda tendo, kie okazis vica aranĝo. 
            Diference de Ĉebaltujo, kie ĉio okazadis sur freŝa aero sub suno, en Tihvin tage la suno forestis, kutime pluvis, kaj ni kunvenis en tendoj. 
            Eĉ en granda tendo, se ĝi entenas multajn homojn, la aero varmiĝas. 
            La programo indikis, en kiu tendo okazos kio, kaj tien sin ŝtopis granda tumulto, krom la aborigenoj. 
            Evidentiĝis, ke sufiĉe multe da popolanoj ne dormis nokte kaj kompensis la mankon tage, kaj tiu socia fenomeno eĉ ricevis sian propran nomon: tiajn dormantojn tage dum komunaj okazaĵoj oni nomis “kadavretoj”😀
        </p>
        
        <p class="mb-3">
            Kun tiu afero estas kunligita unu el miaj plej agrablaj rememoroj pri Tihvin.
        </p>
        
        <p class="mb-3">
            Foje mi, kiel kutime, ekdormis en ies tendo; en la mian, malpenan kaj glacian, mi preskaŭ neniam venadis. 
            Subite oni anoncas, ke en tiu tendo okazos konkurso de simultana tradukado, 
            kaj “kadavretojn” sufiĉe senceremonie oni petis forbalaiĝi kaj liberigi lokon por estimataj kaj valoraj personoj – la konkursantoj. 
            Unue, mi ne volis eliri al malseka malvarma korto; kaj due – mi simple indigniĝis pro tia rilato, kaj decidis pruvi, ke ankaŭ mi estas valora… 
            Unuvorte, mi reviviĝis kaj deklaris, ke mi ne estas “kadavreto”, sed volas partopreni la konkurson. 
            Oni ŝultrolevis, sed enskribis min.
        </p>
        
        <p class="mb-3">
            Mi ekkoleris kaj, sub influo de emocioj… 
            Nun mi ne memoras, ĉu la duan aŭ trian lokon mi okupis (inter sufiĉe spertaj e-istoj😀), 
            sed sekvatage dum komuna kunveno oni solene gratulis min kaj enmanigis la libron “Paŝoj al plena posedo” de W. 
            Auld. 
            Tiu libro vere helpis al mi “pli plene ekposedi Eon”. 
            Sed eĉ pli grava estis la rekono. 
            Kaj mi en mi mem, kaj aliuj unuan fojon ekvidis en mi ne simple knabinon ĝuantan etoson, sed eventuale la seriozan aganton. 
            Ajnaokaze, post tio mi ekhavis certecon pri mi mem, kio tre gravas por juna homo. 
            Mi komencis traduki poemojn, verki rakontojn…
        </p>
        
        <p class="mb-3">
            Sed dume daŭris la tendara vivo. 
            Por mia feliĉo, pluvis nur tage, kaj noktoj estis sekaj kaj stelriĉaj. 
            La vivo fariĝis pli organizita: noktoj apud lignofajro, tage kelkaj horoj da dormo en fremdaj tendoj, kaj denove – prelegoj, seminarioj, diskutoj… 
            Kaj se tage, hazarde, ne pluvis, mi kelkajn horojn seninterrompe ludis badmintonon; ne lastvice por simple varmiĝi😀
        </p>
        
        <p class="mb-3">
            Nia lignofajro kaj kantanta Nataŝa ĉiutage allogadis pli kaj pli multe da homoj; kaj se la unuan tagon ni estis nur kvarope, 
            do la finajn tagojn ĉe lignofajro noktumis jam pli ol duono de la loĝantaro de l’ tendaro. 
            Nataŝa kantis…
        </p>
        
        <p class="mb-5">
            En la sekva historio de SEJT’oj kaj SEJM ŝi estas konata kiel Nataŝa Berce. 
        </p>


        
        <p class="mb-3">
            Kaj jen tria plej bela rememoro – Armenio!
        </p>
        
        <p class="mb-3">
            Ĉio estas nova, helbrila, interesa!
        </p>
        
        <p class="mb-3">
            Ni navigis per granda turisma ŝipo, kiu haltis en rimarkindaj havenoj survoje, kie okazadis ekskursoj al lokaj vidindaĵoj; 
            kaj en Soĉi ni elŝipiĝis por gasti ĉe e-istino Galina. 
            Ni vizitis faman arb-ĝardenon kaj parkon, kaj ĝuis ekzotikon dormi surbalkone en hamako😀 Ja varmege estis!
        </p>
        
        <p class="mb-3">
            Sed poste la aferoj pasis eĉ pli ekzotike! 
            Ni daŭrigis la vojon per trajno, kiu kelkajn horojn iris preskaŭ laŭ la ŝtata limo kun Turkio! 
            En tiu tempo (1984) mi eĉ imagi ne povis, ke iam eblos viziti eksterlandon! 
            Kaj jen ĝi, videblas el fenestro! 
            La sama forbruligita de suno, ruĝa kaj okra grundo, sur ĝi – ŝafaroj; sed estas jam eksterlando! 
            Dum kelkaj horoj mi ne foriris de la fenestro.
        </p>
        
        <p class="mb-3">
            Same ekzotike influis nin Armenio. 
            Ni loĝis en turistejo inter du montoj. 
            Por loĝanto de ĉemara stepo neimageblis, ke la suno videblas nur parton de la tago: ĝi leviĝis elpost unu monto kaj malaperis post la dua iam je la 5-a tage. 
            Sed dum ĝi troviĝis super ni, varmegis arde. 
            Tial ĉiuj tendaranoj ĝojis, kiam iutage ni festis Vardavar – armena somera festo, dum kiu oni priverŝas unu la alian per akvo. 
            Dum varmego tio estas plezuro; sed ne por ĉiuj😀. 
            Mia sesjara filo kun ĝuo rakontis, ke li verŝis akvon al la poŝo de iu viro (laŭstature li ĝuste atingis la poŝon de plenaĝulo). 
            Ĉu ĝuis la eventon tiu viro, la historio silentas😀
        </p>
        
        <p class="mb-3">
            Ankoraŭ mi memoras ŝnurdanciston dum tiu festo. 
            Inter du fostoj oni streĉis ŝnuregon, kaj loka virtuozo montris tiajn miraklojn, ke mi apenaŭ kredis al miaj propraj okuloj! 
            Li komence paŝadis laŭ la ŝnuro, poste kuris, dancis, transkapiĝis, paŝis dorse antaŭen… 
            Poste li iris kun vinditaj okuloj kaj nigra kapuĉo surkape. 
            Kaj plej frapa: fine li alligis al gamboj du ŝnurojn, ĵetis ilin suben kaj proponis, ke infanoj alkroĉiĝu al tiuj ŝnuroj kaj balanciĝu, 
            turniĝu sur ili, dum li paŝos surŝnure. 
            Kompreneble, mia filo kaj ankoraŭ unu knabeto alkroĉiĝis, kaj balancis kaj turnis sin… 
            sed la artisto daŭrigis la vojon! 
            Sen ajna asekuro! 
            Kaj tute bonorde atingis la finan foston. 
            Mi admiregis.
        </p>
        
        <p class="mb-3">
            Ankaŭ memorindas ravaj ekskursoj al tenejo de antikvaj armenaj manuskriptoj Matenadaran; al Eĉmiadzin, 
            rezidejo de l’gvidanto de armena eklezio; al antikvaj preĝejoj Garni kaj Gegard, al la lago Sevan… 

        </p>
        
        <p class="mb-3">
            La beleco de naturo, bonkoreco kaj sincera zorgo de l’ organizantoj pri ni, elstara talenteco de armena popolo, 
            rivelanta sin en arkitekturo, muziko, dancoj, en pentroarto kaj en popolaj kutimoj – ĉio tio faris Erevanan tendaron neforgesebla. 
            Jes, mi ne memoras en ĝi iujn pure Esperantajn eventojn. 
            Sed la mem eblecon ektuŝi kaj ekscii senpere la historion kaj kulturon de alia popolo donis al ni ĝuste Esperanto. 

        </p>
        
        <p class="mb-3">
            Vere, tio estis la plej belaj tagoj, prilumitaj per radio de rememoro, sin banantaj en sunbrilo; tagoj de plena feliĉo, 
            de ĝojo pro komunikado kaj interkompreno kun samideanoj; tagoj de malfermiteco al la mondo, kiu akceptas vin.
        </p>
        
        <p class="mb-3">
            Tio ne estas severa grafiko, kie dominas rekta linio, gvidanta klare de komenco al fino. 
            Tio estas pentroarto, impresionismo, kie el aparaj kolormakuloj kreiĝas en la kapo de l’ spektanto hela kaj kompleta bildo de tiuj emocioj, 
            kiujn volis komuniki al spektanto la aŭtoro. 
            Kaj impresionismo ĉiam temas pri la ĝojo de l’ vivo. 

        </p>
        
        <p class="mb-3">
            La lando Esperantujo ne ekzistas surmape. 
            Al ĝi ne flugas aviadiloj, ne veturas trajnoj… 
            Sed almenaŭ unufoje jare eblas, kun dorsosako aŭ valizo, sin direkti al tiu imagita lando, kie ĉiuj komprenas vin, 
            kie ĉiuj homoj estas valoraj kaj samvaloraj.
        </p>
        
        <p class="mb-3">
            Pri tia lando revis d-ro Zamenhof, kiam en 1887 li eldonis “Lernolibron de internacia lingvo”. 
            Kaj antaŭ, kaj post li aperadis centoj da similaj projektoj: la lingvo Solresol, 
            kie la vortojn simbolis kunmetaĵo de sonoj aŭ koloroj; analitikaj lingvoj de Leibniz kaj Descartes; kaj nuntempaj provoj, de ido ĝis klingon. 
            Sed nur unu lingvo fariĝis viva interkomunikilo: en ĝi oni parolas, verkas, filmas kaj surscenigas, amdeklaras kaj edukas infanojn. 
            Tiu lingvo estas Esperanto. 

        </p>
        
        <p class="mb-3">
            Kaj ni bonŝancas, ke ni ne nur en revoj, sed en realo povas vivi en tiu feliĉa lando. 
        </p>
        
        <p class="mb-3">
            Ni estas esperantistoj.
        </p>
    </div>
    `
  )
}

const itemName = {
  esp: `Mia plej bela esperanto rememoro`
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp
  }
}

export default item;